import axios from './axios'
import qs from "qs";

function service(endpoint = '') {

    function annual(id, data = {}) {
        return axios.get(`${endpoint}/${id}/annual-evaluation`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function monthly(id, category, month, data = {}) {
        return axios.get(`${endpoint}/${id}/categories/${category}/month/${month}`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function annualList(id, data = {}) {
        return axios.get(`${endpoint}/annual-evaluations`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        annual,
        annualList,
        monthly
    }
}

export default service
